type ShopifyOAuthParams = {
  shop: string;
  clientId: string;
  redirectUri: string;
  scopes?: string; // default: 'read_products,write_products'
  accessMode?: 'per-user' | 'offline';
};

type ShopifyAuthResult = {
  url: string;
  nonce: string;
};

export const generateShopifyOAuthUrl = ({
  shop,
  clientId,
  redirectUri,
  scopes = 'read_products,write_products,write_draft_orders,read_draft_orders,read_orders,write_orders',
  accessMode = 'offline',
}: ShopifyOAuthParams): ShopifyAuthResult => {
  const nonce = btoa(crypto.randomUUID()); // create a base64-encoded random string

  const params = new URLSearchParams({
    client_id: clientId,
    scope: scopes,
    redirect_uri: redirectUri,
    state: nonce,
  });

  const url = `https://${shop}/admin/oauth/authorize?${params.toString()}&grant_options[]=${accessMode}`;

  return { url, nonce };
};

export function extractShopifyProductId(gid: string): string {
  const parts = gid.split('/');
  return parts[parts.length - 1]; // returns "7890786975837"
}

export function makeShopifyProductGid(productId: string | number): string {
  return `gid://shopify/Product/${productId}`;
}
